import "./EditUserOnSite.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditUserOnSiteComponentController from "./EditUserOnSiteComponentController";

export class EditUserOnSiteComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditUserOnSiteComponentController;
        this.templateUrl = "/App/Components/Site/UsersList/EditUserOnSite/EditUserOnSite.html";
    }
}

module("mmManagePortal").component("mmEditUserOnSite", new EditUserOnSiteComponent());
